import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import ReduxThunk from "redux-thunk";
import authReducer from "./reducers/authReducer";
import { contentReducer } from "./reducers/contentReducer";
import feedReducer from "./reducers/feedReducer";
import mainReducer from "./reducers/mainReducer";
import toastReducer from "./reducers/toastReducer";
import { current_userReducer } from "./reducers/current_userReducer";

import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import curriculaReducer from "./reducers/curriculaReducer";
import seminarReducer from "./reducers/seminarReducer";

// const rootReducer = combineReducers({
//     main: mainReducer,
//     feed: feedReducer,
//     auth: authReducer,
//     content: contentReducer
// })

// const store = createStore(
//     rootReducer,
//     compose(
//         applyMiddleware(ReduxThunk),
//         window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f,
//     )
// );

// export default store;

////// redux-persist

const rootReducer = combineReducers({
  toast: toastReducer,
  main: mainReducer,
  feed: feedReducer,
  auth: authReducer,
  content: contentReducer,
  current_user: current_userReducer,
  curricula : curriculaReducer,
  seminar : seminarReducer
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["content"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(persistedReducer, compose(applyMiddleware(ReduxThunk), window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f) => f));
export const persister = persistStore(store);
